import {validationMixin} from 'vuelidate'
import {
    required,
    email,
    minLength,
    maxLength
} from 'vuelidate/lib/validators'

export default {
    props: {
        title: {
            type: String,
        },
        type: {
            type: String,
        },
        description: {
            type: String,
        },
        helpText: {
            type: String,
        },
        labelFor: {
            type: String,
        },
        value: {},
        maxLength: {
            type: Number,
        },
        name: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean
        },
        readOnly: {
            type: Boolean
        },
        selectOptions: {
            type: Array|Object,
            default: function () {
                return {};
            },
        },
        required: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String
        }
    },
    mixins: [
        validationMixin,
    ],
    data: function() {
        return {
            localValue: this.value,
            textareaHeight: false,
            errorMessage: this.error
        }
    },
    watch: {
        error: function(newVal, oldVal) {
            this.errorMessage  = newVal;
        }
    },
    computed: {
        model: {
            get () {
                return this.localValue
            },
            set (value) {
                this.$nextTick(() => {
                    this.localValue = value;
                    this.$emit("input", value);
                    this.validate();
                    this.setErrorMessage();
                })
            }
        }
    },
    validations: function() {
        let validationRules = {};

        if(this.required) {
            validationRules.required = required;
        }

        if(this.type == "email") {
            validationRules.email = email;
        }

        return {localValue: validationRules};
    },
    methods: {
        setErrorMessage() {
            const validation = this.getValidationObject();

            if(validation.hasOwnProperty('required') && ! validation.required) {
                this.errorMessage = t("This field is required");
            }else if(validation.hasOwnProperty('email') && ! validation.email) {
                this.errorMessage = t("Please enter a valid email address");
            } else {
                this.errorMessage = null;
            }
        },
        validate() {
            const validation = this.getValidationObject();
            let isValid = true;

            if(validation) {
                validation.$touch();
                isValid = validation.$invalid != true;
            }
            return isValid;
        },
        getValidationObject() {
            return this.$v.localValue;
        },
    },
}



// WEBPACK FOOTER //
// ./src/modules/form/mixins/FieldMixin.js